import { Span, Wrapper } from './CardIconTitle.style'
import { Icon, IconProps } from './IconComponent/Icon'

export type CardIconTitleProps = IconProps & {
  title: string
  color?: string
}

export function CardIconTitle({
  title,
  background,
  icon,
  color,
}: CardIconTitleProps) {
  return (
    <Wrapper>
      <Icon background={background} icon={icon} />
      <Span color={color}>{title}</Span>
    </Wrapper>
  )
}
